import { Config } from './types'

const localConfig: Partial<Config> = {}

export default localConfig
